import React from 'react'
import YachtSlider from './YachtSlider'
import { Modal, Button } from "react-bootstrap";

const ServiceModal = ({ service, show, handleClose }) => {
    if (!service) return null;
    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{service.serviceName} - Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row">
                            {/* <div className="col-md-6">
                                <YachtSlider yachtImages={yacht.images} />
                            </div> */}

                            <div className="col-md-12 mt-md-0 mt-3">
                                {/* <h3 className="mb-3">{yacht.name}</h3> */}
                                <h2 class="mb-3">
                                    <b>
                                        {service.serviceName}
                                    </b>
                                </h2>

                                {service.data && service.data.map((item, index) => {
                                    const Tag = item.tag;
                                    return <Tag key={index}>{item.text}</Tag>;
                                })}
                                {/* <button className="book-btn py-2" style={{ "backgroundColor": "transparent","padding": "10px 20px", "borderRadius": "30px" }}>Book Now</button>
                                <button className="book-btn py-2"
                                    style={{ "backgroundColor": "#25d366", "marginLeft": "10px", "padding": "10px 20px", "borderRadius": "30px" }}>
                                    Whatsapp
                                </button> */}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default ServiceModal